import { Card, Tooltip } from "antd";
import React from "react";

const VibhagCard = ({ vibhagName, imageSrc, onClick }) => {
  return (
    <Card
      hoverable
      className="card-border"
      style={{
        width: "auto",
        padding: 10,
        cursor: "pointer",
      }}
      bodyStyle={{ padding: 12 }}
      cover={<img alt="example" src={imageSrc} />}
      onClick={onClick}
    >
      <Card.Meta title={<Tooltip title={vibhagName}>{vibhagName}</Tooltip>} />
    </Card>
  );
};

export default VibhagCard;
